goog.provide('el8.uiwidget.NewMindreader');

goog.require('el8.service.Search');
goog.require('el8.template.uiwidget.NewMindreader');
goog.require('el8.util.string');


/**
 * This is our autocomplete / autosuggest widget.
 *
 * It is capable of autocompleting (returning a structured items) and
 * autosuggesting (returning unstructured text) and of searching
 * via AJAX and searching a locally defined list. It can also do
 * a specific kind of hybrid search, where it uses a local list
 * when a user clicks into the field and an AJAX search for
 * actual queries (but not of merging local and remote searches.)
 *
 * It is often used via mindreaderOpts passed into a Form.
 * See mindreaderOpts.js to see the configuration for many different
 * mindreaders. See addEditImmunization.js for examples of a few
 * different mindreaders (both AJAX and local).
 *
 * One place you may run into trouble: the user event handling code
 * here can be fairly fragile, especially when combined with other widgets
 * (listeditor, multilist) that have their own click/blur/keydown listeners.
 * Adding a new kind of use for one of these widgets or layering a new
 * widget on top of / under this one can reveal issues there.
 *
 * (There is also LegacyMindreader, which is deprecated but
 *  used in some older code.)
 */
el8.uiwidget.NewMindreader = function(opts) {

    this._isInit = false;
    this._HIGH_Z_INDEX = 10000; // dropdown always on top
    this._INVALID_KEYS = {
        9: true,   // tab
        13: true,  // enter
        16: true,  // shift
        17: true,  // ctrl
        18: true,  // alt
        20: true,  // caps lock
        27: true,  // escape
        33: true,  // page up
        34: true,  // page down
        35: true,  // end
        36: true,  // home
        37: true,  // left arrow
        38: true,  // up arrow
        39: true,  // right arrow
        40: true,  // down arrow
        45: true   // insert
    };
    this._QUERY_DELAY = 0.15;

    /*********************************************
     * Extract all the opts that can get passed in
     *********************************************/
    opts = opts || {};

     // the second param says: just do prefix matching, no edit-distance/similarity matching
     // which makes local search more similar to our Solr searches
    this._searchService = opts.data ? new el8.service.Search(opts.data, true, opts.rowToStringFn) : false;
     // emptyQueryData (results to show for an empty query) is only available when there's no local search
    this._emptyQueryData = (opts.emptyQueryData && !opts.data) ? opts.emptyQueryData : null;
    this._emptyQueryText = opts.emptyQueryText;

    // hide the mindreader if there are no results, rather than displaying a message that there are no matches
    // defaults false and should only be turned on for fields that are more often free-text than not
    this._hideNoResults = (opts.hideNoResults === true);

    /**
     * Specs re: search query
     */
    this._url = opts.url || null;
    this._urlParams = opts.urlParams || {};
    // if passed in as a spec, it should be a function that returns a dictionary of data
    // that should also be included in the search query params
    this._dynamicQueryParamsFn = opts.dynamicQueryParamsFn || function() { return {}; };
    this._minQueryLength = (opts.minQueryLength === undefined) ? 2 : opts.minQueryLength;
    this._limit = opts.limit || 100;
    this._queryDelay = opts.queryDelay || null;

    /**
     * Event handler hooks
     */
    this._selectFn = opts.selectFn || function() {};  // Called only when a server result is selected
    this._changeFn = opts.changeFn || null; // Also called if for free-text or a cleared field
    this._hideFn = opts.hideFn || null;

    // This thing is a hack. There are crazy interactions between the various
    // event handlers in here and in the multilist. Calling this function
    // when the user clicks without selecting an entry makes our life
    // easier there.
    this._multilistClickOffFn = opts.multilistClickOffFn || null;

    this._hasValidation = (opts.hasValidation === true); // defaults to false

    /**
     * Size, position of display results
     */
    this._entryHeight = opts.entryHeight || 40;
    this._containerWidth = opts.containerWidth || 450;
    this._containerHeight = opts.containerHeight || 250;
    this._entryContainerClasses = opts.entryContainerClasses || ["el8MRItem"];

    // If we are going to overflow the input (because our container
    // width is larger than our input/anchor width), align the MR's
    // right side to the anchor's right side and overflow to the left.
    // This is useful for elements that are up against the right edge
    // of the screen. If true, containerLeftOffset will be ignored.
    this._overflowInputToLeft = (opts.overflowInputToLeft === true);

    // Anchor the dropdown from the bottom; useful when you know you
    // will render at the bottom of the page and need to drop up instead
    // of down. Defaults to false.
    this._anchorFromBottom = (opts.anchorFromBottom === true);

    this._containerLeftOffset = opts.containerLeftOffset || null;
    this._containerTopOffset = opts.containerTopOffset || null;

    // Can be used to pin the dropdown to a broader container of the input,
    // if the input moves around. Will default to this.$inputField
    this._dropdownAnchor = opts.dropdownAnchor || null;

    // Gets used to help osition the results; most of the time, this widget will
    // be used from app proper (so we'll use el8.app.pageLayout) but sometimes
    // it's used in other contexts (like onboarding) and will need a different UILayout
    this._UILayoutFn = opts.UILayoutFn || function() { return el8.app.pageLayout; };

    /**
     * Formatting of the search results
     */
    this._formatResult = opts.formatResult || function(obj) { return obj; };  // XSS OK -KF (rely on caller)
    this._formatSelected = opts.formatSelected || function(obj) { return obj; };
    this._customRenderFn = opts.customRenderFn || function() {};
    this._customContainerFn = opts.customContainerFn || null;

    /**
     * This function returns:
     *   - info text div
     *   - the results divs
     *   - the search query term
     *   - the raw results
     *   - number of results
     *   - the hide function for this particular MR
     *   - the force-show function for this particular MR
     * It is useful for making modifcations to the MR's display without rewriting the whole render function */
    this._modifyRenderCb = opts.modifyRenderCb || null;
    /**
     * NOTE: this is a wacky property added because we don't want to deal with
     * rewriting the rendering API for this component. Utilizing this property
     * seemed to be one of the safer ways to solve an immediate issue (see below) without
     * causing any regressions. This should not be used much because our work should
     * be mostly React going forward, and we should try to delete this widget ASAP.
     *
     * This component has a very weird direct dependency on the structure
     * of our back end's search endpoint responses, such that if a particular search
     * endpoint deviates from the structure expected by this component, you have to
     * write a bunch of custom logic to render the results dropdown and can't
     * rely on most of the rendering logic that is already in place.
     *
     * This new property is intended for use with search endpoint responses that do NOT
     * match the structure expected by this component but can be easily transformed
     * into the expected structure. The function should accept the raw search result response
     * from the server, and return a structure usable by the `renderResults` function.
     */
    this._transformResultsForRender = opts.transformResultsForRender || false;

    // opts.actions is an array of dicts with two required keys and an opt. key
    // required: { 'name': 'View all...', 'actionFn': function() { do this...; } }
    // optional: 'preserveValOnClick' - don't clear the input when this actionFn runs
    this._actions = opts.actions || [];
     // do actions always float on top?
    this._fixedPosActions = Boolean(opts.fixedPositionActions && this._actions.length);
     // list actions first, instead of last
    this._actionsFirst = (opts.actionsFirst === true);

    /**
     * Behavior of the search results
     */
    this._noCache = (opts.noCache !== false); // defaults to true
     // defaults to false but is always on when emptyQueryData is on
    this._showOnFocus = (opts.showOnFocus === true || Boolean(this._emptyQueryData));
    this._showOnFocusOnce = (opts.showOnFocusOnce === true);

     // defaults to false; only works in combo with listeditor right now
    this._listeditor = (opts.listeditor === true); //defaults to false
    this._focusAfterSelect = (opts.focusAfterSelect !== false); // defaults to true

    // avoid repeatedly showing the empty query data in listeditor-mindreaders with emptyQueryData; defaults to false
    this._noRepeatEmptyQuery = (opts.noRepeatEmptyQuery === true);
    if (this._noRepeatEmptyQuery) { this._focusAfterSelect = true; } // focusAfterSelect would be incompatible

    this._adviceText = opts.adviceText || 'Enter more information to narrow search.';

    this._sectionToTitleMap = $.extend({},
        el8.uiwidget.NewMindreader.nameToTitleMap,
        opts.sectionToTitleMap || {}
    );
};

// *****************************
// List of mappings from section names to titles
// *****************************
el8.uiwidget.NewMindreader.nameToTitleMap = {
    popular: 'Most Popular',
    matches: 'Best Matches',
    other: 'Other Matches',
    preferred: 'Patient Preferred',
    contacts: 'Results from Contacts',
    npidata: 'Results from National Provider Index',
    snomed_mapped: 'ICD-9s with an exact SNOMED match',
    snomed_unmapped: 'ICD-9s without an exact SNOMED match',
    favorites: 'Saved Rx Templates'
};

// *****************************
// Local search service
// *****************************
el8.uiwidget.NewMindreader.prototype.updateSearchData = function(data) {
    if (this._searchService) {
        this._searchService.setRows(data);
    }
};

// *****************************
// Main initialization function
// *****************************
el8.uiwidget.NewMindreader.prototype.init = function(_input) {

    if (!_input) { return false; }

    this.popoverId = (_input.attr('name') || 'unknown') + '-popover-' + Date.now().toString();

    this.isShown = false;
    this.isEnabled = true;   // Initialize in enabled state
    this.isFrozen = false;
    this.isBusy = false; // Whether in the midde of requesting results
    this.hasActivity = false;
    this.isEngaged = false;  // Whether user has engaged in dropdown
    this.isBeingClicked = false; //Whether a user click on the MR is currently being processed

    this.isClickBinded = false;
    this.ignoreRequest = false;

    this.resultsMap = {}; // Holds map of result arrays returned by server
    this.selectedItem = null;
    this.madeSelection = false;

    this.activeIndex = -1;          // Index of active result within container
    this.activeItem = null;
    this.$activeResult = null;      // Pointer to current active result

    this.delayTimeout = null;
    this.inFocus = null;

    this.activeRequest = null;

    if (!this._isInit) { this.cache = {}; }

    // --------------------
    // If already init, make sure to remove and unbind old inputField
    // --------------------
    if (this._isInit) {
        this.$inputField.removeClass("mr-input-field");
        this.unbindInputHandlers(this.$inputField);
        this.unbindClickHandler();
    }
    this.$inputField = _input;
    this.$inputField.addClass("mr-input-field");
    this._dropdownAnchor = this.$inputField;
    this.bindInputHandlers(this.$inputField);

    this.$inputField.attr('aria-haspopup', true);
    this.$inputField.attr('aria-controls', this.popoverId);

    // Get info text ignore string
    this.ignoreStr = _input.attr('_infotext') || "";

    // --------------------
    // Build results display on first initialization
    // --------------------
    if (!this._isInit) {
        var hasActions = Boolean(this._actions.length);
        if (!this._customContainerFn) {
            this.$dropdownContainer = $(el8.template.uiwidget.NewMindreader.container({
                hasActions: hasActions,
                fixedPos: this._fixedPosActions,
                actionsFirst: this._actionsFirst
            }));
        } else {
            this.$dropdownContainer = $(this._customContainerFn());
        }
        this.$dropdownContainer
            .attr('id', this.popoverId)
            .hide()
            .css({ top: this.$inputField.outerHeight() + "px" })
            .appendTo(document.body);
        this.$dropdownContent = $('.mr-dropdown-content', this.$dropdownContainer);

        // --------------------
        // Add action items
        // --------------------
        if (hasActions) {
            this.$actionsSection = $('.mr-actions', this.$dropdownContainer);
            for (var i=0; i<this._actions.length; i++) {
                var a = this.createDropdownItem("action", i, ['mr-action-item', 'el8MRItem'].concat(this._actions[i].isDisabled ? ['el8MRItemDisabled'] : []));
                a.text(this._actions[i]['name']);
                this.$actionsSection.append(a);
            }
        }
    }

    this._isInit = true;
    return this;
};

// *****************************
// Methods to fetch data
// *****************************
el8.uiwidget.NewMindreader.prototype.delay = function(callback, str, l) {
    if (this.delayTimeout) { this.clearDelay(); }
    this.delayStr = str;
    this.delayTimeout = setTimeout(function() {
        callback();
    }, l * 1000);
};
el8.uiwidget.NewMindreader.prototype.clearDelay = function() {
    if (this.delayTimeout) { clearTimeout(this.delayTimeout); }
    this.delayTimeout = undefined;
};
el8.uiwidget.NewMindreader.prototype.clearRequest = function() {
    this.clearDelay(); // clear the delay, if any
    this.ignoreRequest = true; // remains true until new results requested
};
el8.uiwidget.NewMindreader.prototype.requestResults = function(str) {
    if (!this.isEnabled || this.isFrozen) { return; }
    // If have local searchService, show all values upon down arrow on empty str (up to limit)
    if (str.length === 0 && (this._searchService || this._emptyQueryData)) {
        var data;
        if (this._searchService) {
            data = this._searchService.getRows();
        } else if (this._emptyQueryData) {
            data = (jQuery.isFunction(this._emptyQueryData)) ?
                this._emptyQueryData() : this._emptyQueryData;
        }
        if (data) {
            var maxMatches = data.slice(0, this._limit);
            this.renderResults(maxMatches, str);
            return;
        }
    }
    if (!this.isValidInput(str)) { this.hide(); return; }
    if (str.length < this._minQueryLength) { this.hide(); return; }
    this.ignoreRequest = false;
    this.madeSelection = false;
    // Do local search if specified
    if(this._searchService) {
        this.requestLocalResults(str);
        return;
    // Otherwise, lookup in cache or search on server
    } else {
        var that = this;
        var lookup = !this._noCache ? this.lookupInCache(str) : null;
        if (lookup) {
            this.renderResults(lookup, str);
            this.clearDelay();
        } else {
            var queryFn = function(_str) {
                return function() {
                    that.isBusy = true;
                    var dataDict = that._urlParams;
                    // add any additional dynamic query params
                    var dynamicQueryParams = that._dynamicQueryParamsFn();
                    Object.keys(dynamicQueryParams).forEach(function(field) {
                        dataDict[field] = dynamicQueryParams[field];
                    });
                    dataDict['q'] = _str;
                    dataDict['limit'] = that._limit;
                    var url = jQuery.isFunction(that._url) ? that._url() : that._url;
                    that.renderResultsInProgress(_str);
                    if (that.activeRequest && that.activeRequest.state() === 'pending') {
                        that.activeRequest.abort();
                    }
                    that.activeRequest = $.el8_ajax({
                        url: url,
                        data: dataDict,
                        type: 'get',
                        //dataType: 'json',
                        success: function(data) {
                            if (!that._noCache) { that.addToCache(_str, data); }
                            if (!that.ignoreRequest) {
                                that.renderResults(data, _str);
                            }
                            that.isBusy = false;
                        }
                    });
                };
            };
            this.delay(queryFn(str), str, this._queryDelay ? this._queryDelay : this._QUERY_DELAY);
        }
    }
};
el8.uiwidget.NewMindreader.prototype.requestLocalResults = function(str){
    var that = this;
    this._searchService.requestMatchingRows(str, this._limit, function(token, matches){
        that.renderResults(matches, str);
    });
};
el8.uiwidget.NewMindreader.prototype.renderResults = function(_results, str) {

    /**
     * API for _results
     * 1) Multiple sections
     *    {
     *      sections: ['matches', 'popular', 'suggested'],
     *      matches: [...<results>...],
     *      popular: [...<results>...],
     *      suggested: [...<results>...],
     *    }
     *
     * 2) Single section with no title
     *   {
     *      matches: [...<results>...],
     *      total_count: 100
     *   }
     *
     * 3) Custom
     *   {
     *      results: [....<results>...],
     *      custom: true
     *   }
     *
     * 4) Default
     *   [...<results>...]
     */

    if (!this.isEnabled || this.isFrozen) { return; }

    if (this._transformResultsForRender) {
      _results = this._transformResultsForRender(_results);
    }

    var mrSections = []; //for modifyRenderCb

    this.reset();
    // defer showing results for empty searches or if we're specifically
    // avoiding showing a message for result-less queries
    if (str && !this._hideNoResults) { this.show(true); }
    this.resetResultsDisplay();

    if (_results['custom']) {
        $('.mr-subheader', this.$dropdownContainer).show();
        this.customRenderResults(_results['results']);
        this.resetScroll();
        return;
    }

    // If we just get a single array, treat it as "matches"
    if (_results instanceof Array) {
        this.resultsMap = { 'matches': _results };
    } else {
        this.resultsMap = _results;
    }

    var numMatches = 0;
    $('.mr-results', this.$dropdownContainer).empty().removeClass('dataLoading');

    /* Multiple titled sections */
    if (this.resultsMap['sections'] && this.resultsMap['sections'].length) {
        var sections = this.resultsMap['sections'];
        for (var i=0; i<sections.length; i++) {
            var name = sections[i];
            mrSections.push($('.mr-'+name, this.$dropdownContainer));

            var title = this._sectionToTitleMap[name];
            $('.mr-results', this.$dropdownContainer).append(
                el8.template.uiwidget.NewMindreader.resultsSection({
                    title: jQuery.isFunction(title) ? title() : title,
                    name: name
                })
            );
            var results = this.resultsMap[name];
            if (results) {
              for (var j=0; j<results.length; j++) {
                numMatches++;
                var a = this.createDropdownItem(
                  name,
                  j,
                  ['mr-result-item'].concat(this._entryContainerClasses)
                );
                a.html(this._formatResult(results[j]));
                $('.mr-'+name, this.$dropdownContainer).append(a);
              }
            }
        }
        if (numMatches) {
            $('.mr-results-info', this.$dropdownContainer).text(
                'Displaying results for "' + str +'".'
            );
        } else {
            $('.mr-results-info', this.$dropdownContainer).text(
                'No results found for "' + str +'".'
            );
            $('.mr-results', this.$dropdownContainer).empty();
        }

    /* Single section with no title */
    } else {
        var name = 'matches';
        var results = this.resultsMap[name];
        if (results == undefined) {
            if (this._hideNoResults) {
                this.hide();
            } else {
                $('.mr-results-info', this.$dropdownContainer).text(
                    'No results found for "' + str +'".'
                ).show();
            }
            return;
        }
        $('.mr-results', this.$dropdownContainer).append(
            el8.template.uiwidget.NewMindreader.resultsSection({
                name: name
            })
        );
        mrSections.push($('.mr-'+name, this.$dropdownContainer));

        for (var j=0; j<results.length; j++) {
            numMatches++;
            var a = this.createDropdownItem(name, j,
                ['mr-result-item'].concat(this._entryContainerClasses));
            a.html(this._formatResult(results[j]));
            $('.mr-'+name, this.$dropdownContainer).append(a);
        }
        if (!isNaN(this.resultsMap['total_count'])) {
            var totalCount = this.resultsMap['total_count'];
            if (totalCount) {
                if (totalCount > numMatches) {
                    $('.mr-results-info', this.$dropdownContainer).text(
                        'Displaying ' + numMatches + ' results of ' +
                        totalCount + ' for "' + str +
                        '".  '+this._adviceText
                    ).show();
                } else {
                    $('.mr-results-info', this.$dropdownContainer).text(
                        'Displaying all ' + numMatches + ' results for "' + str +'".'
                    ).show();
                }
            } else {
                $('.mr-results-info', this.$dropdownContainer).text(
                    'No results found for "' + str +'".'
                ).show();
            }
        } else {
            if (numMatches) {
                $('.mr-results-info', this.$dropdownContainer).text(
                    'Displaying results for "' + str +'".'
                );
            } else {
                $('.mr-results-info', this.$dropdownContainer).text(
                    'No results found for "' + str +'".'
                );
            }
        }
    }

    // we deferred showing the MR for empty queries to see if there were actually results
    if (!str && numMatches) { this.show(true); }
    if (str && this._hideNoResults) {
        // or we deferred showing the MR because we only want to show it when there are matches
        if (str && numMatches) {
            this.show(true);
        // and make sure that if the MR was already open but now has no results, we hide it
        } else {
            this.hide();
        }
    }

    if (this._emptyQueryText && !str && numMatches) {
        $('.mr-results-info', this.$dropdownContainer).text(this._emptyQueryText);
    }
    if (this._modifyRenderCb) {
        var that = this;
        var args = {
            searchString: str,
            infoDiv: $('.mr-results-info', this.$dropdownContainer),
            actionsDiv: $('.mr-actions', this.$dropdownContainer),
            resultsMap: this.resultsMap,
            numMatches: numMatches,
            mrSections: mrSections,
            showFn: function() {
                that.show.apply(that, true);
            },
            hideFn: function() {
                that.hide.apply(that);
            }
        };
        this._modifyRenderCb(args);
    }

    // Finally, make user input result active and we reset scroll
    this.resetScroll();

    /* Pre-select the first entry if we're returning suggested results without any query
     * (because it makes it easier to keyboard navigate / move quickly)
     */
    if (numMatches > 0 || this._actions.length) {
        if (!str) {
            this.setActiveResult(0, false, true);
        }
    }

};
el8.uiwidget.NewMindreader.prototype.customRenderResults = function(results) {
    this._customRenderFn(this, results);
};
el8.uiwidget.NewMindreader.prototype.renderResultsInProgress = function(str) {
    // defer showing results for empty searches or if we're specifically
    // avoiding showing a message for result-less queries
    if (str && !this._hideNoResults) { this.show(true); }
    this.resetResultsDisplay();
    $('.mr-results-info', this.$dropdownContainer).text(
        'Requesting results for "' + str +'".'
    ).show();
    $('.mr-results', this.$dropdownContent).addClass('dataLoading');
};
el8.uiwidget.NewMindreader.prototype.resetResultsDisplay = function() {
    $('.mr-fyi', this.$dropdownContent).remove();
    $('.mr-results', this.$dropdownContent).empty();
};

// ***************************
// Public methods for fetching selected item
// ***************************
el8.uiwidget.NewMindreader.prototype.getSelectedItem = function() {
    var selectedVal = this.selectedItem ? this._formatSelected(this.selectedItem) : '';
    return el8.util.string.escapedStrEqual(selectedVal, this.getInputVal()) ? this.selectedItem : '';
};
el8.uiwidget.NewMindreader.prototype.setSelectedItem = function(e, item, noTrigger) {
    this.selectedItem = item;
    var val = this._formatSelected(item);
    /* Calling both blur and change events here because the InfoField listens for blur to add/remove
     * the InfoText class, but other listeners should look for change to know if there is a new value.
     *
     * Also, if formatSelected returns null (instead of the empty string), that means something special:
     * a convertTextToItemFn or selectFn is going to be responsible for populating something in here,
     * so don't trigger a change/blur (which will break editing existing entries)
     */
    if (noTrigger || val === null) {
        val = val || '';
        this.$inputField.val(val.el8_unescape());
    } else {
        this.$inputField.val(val.el8_unescape()).blur().change();
    }
    /* If has validation, trigger validation. */
    if (this._hasValidation && this.$inputField.valid) { this.$inputField.valid(); }

    this._selectFn(e || {}, this.selectedItem, this);
};

// ***************************
// Keyboard and mouse handling methods
// ***************************
el8.uiwidget.NewMindreader.prototype.bindInputHandlers = function(_input) {
    var that = this;
    this.keydownHandler = function(e) {
        // First case is when dropdown is displayed
        if (that.isDropdownDisplayed()) {
            switch (e.keyCode) {
                case KEYS.TAB:
                    that.hide();
                    if (that._listeditor) { break; }
                    break;

                case KEYS.ESC:
                    e.preventDefault();
                    that.hide();
                    if (!that._showOnFocus) { return false; }
                    break;

                case KEYS.UP:
                    if (!that.isBusy && that._listeditor && !that.hasResults(true)) {
                        return;
                    }
                    e.preventDefault();
                    that.clearRequest(); // ignore requests already made
                    that.freeze();       // don't make any new requests until new key
                    if (that.$activeResult) {
                        var top = that.$activeResult.position().top;
                        if (top < that._entryHeight) {
                            var scrollTop = that.$dropdownContent.scrollTop();
                            that.$dropdownContent.scrollTop(scrollTop+top-that._entryHeight);
                        }
                        // See the mousemove handler for details about this hacky flag and why it exists
                        that._keydownScroll = true;
                    } else {
                        that.resetScroll();
                    }
                    that.activatePrev();
                    break;

                case KEYS.DOWN:
                    if (!that.isBusy && that._listeditor && !that.hasResults(true)) {
                        return;
                    }
                    e.preventDefault();
                    that.clearRequest(); // ignore requests already made
                    that.freeze();       // don't make any new requests until new key
                    that.isEngaged = true;
                    if (that.$activeResult) {
                        var containerHeight = that.$dropdownContainer.height();
                        if (that._fixedPosActions) {
                            // if the actions section is fixed, it needs to be excluded from the containerHeight
                            containerHeight -= that.$actionsSection.outerHeight();
                        }
                        var bottom = (that.$activeResult.offset().top -
                                that.$dropdownContainer.offset().top) +
                                that.$activeResult.height();
                        if (bottom - containerHeight > -1*that._entryHeight) {
                            var scrollTop = that.$dropdownContent.scrollTop();
                            that.$dropdownContent.scrollTop(scrollTop+bottom-containerHeight+that._entryHeight);
                        }
                        that._keydownScroll = true;
                    } else {
                        that.resetScroll();
                    }
                    that.activateNext();
                    break;

                case KEYS.ENTER:
                    e.preventDefault();
                    if (that._listeditor) { break; }
                    var noBubble = that.selectActiveResult(e);
                    that.clearRequest();
                    if (noBubble) { return false; }
                    break;

                case KEYS.BACKSP:
                    // Cancel any outstanding requests
                    that.clearRequest();
                    break;

                //case KEYS.PAGEUP: /* fall through to default */
                //case KEYS.PAGEDOWN: /* fall through to default */
                default:
                    that.unfreeze();
                    break;
            }
        // Else if dropdown is not displayed
        } else {
            switch (e.keyCode) {
                case KEYS.DOWN:
                    if (!that._listeditor) {
                        that.requestResults(that.getInputVal());
                        return false;
                    }
                    break;

                case KEYS.ESC: // mimic blur
                case KEYS.TAB: // mimic blur
                case KEYS.BACKSP:
                case KEYS.ENTER:
                    // Cancel any outstanding requests
                    that.clearRequest();
                    break;

                default:
                    break;
            }
        }
    };
    this.keyupHandler = function(e) {
        // Need to do search on keyUp, after character is registered
        if (that.isEnabled) {
            if (!(e.keyCode in that._INVALID_KEYS)) {
                that.hasActivity = true;
                if (!(e.keyCode === KEYS.BACKSP && !that.getInputVal())) {
                    that.requestResults(that.getInputVal());
                } else {
                    that.hide();
                }
            }
        }
    };
    this.focusHandler = function(e) {
        if (that._showOnFocus) {
            // if showOnFocus, automatically show dropdown on focus
            that.requestResults(that.getInputVal());
        } else if (!that.madeSelection && that._showOnFocusOnce) {
            // or only show on focus if there hasn't been a selection
            that.requestResults(that.getInputVal());
        } else if (!that.madeSelection && !that.hasInput()) {
            that.show();
        }
        that.unfreeze();
    };
    if (this._changeFn) {
        this.changeHandler = function(e) {
            /* When you click on an entry from the dropdown, it triggers two change events
             * in a row. The first one comes from the fact that the user has typed something
             * and blurred. The second comes from our actual mindreader selection.
             *
             * We don't want to call the changeFn for the former, so we look to see if
             * the MR is still open and if we're in between a mouseup and mousedown
             * (and short circuit if so). */
            if (that.checkIsVisible() && that.checkIsBeingClicked()) { return; }
            that._changeFn(e, that);
        };
    }

    if (!this.isInputBinded) {
        _input.attr("autocomplete", "off")
            .on('keyup', this.keyupHandler)
            .on('keydown', this.keydownHandler)
            .on('focus', this.focusHandler);
        if (this.changeHandler) { _input.change(this.changeHandler); }
        this.isInputBinded = true;
    }
};
el8.uiwidget.NewMindreader.prototype.unbindInputHandlers = function(_input) {
    if (this.isInputBinded) {
        _input.unbind('keyup', this.keyupHandler)
            .unbind('keydown', this.keydownHandler)
            .unbind('focus', this.focusHandler);
        if (this.changeHandler) { _input.unbind('change', this.changeHandler); }
        this.isInputBinded = false;
    }
};
el8.uiwidget.NewMindreader.prototype.bindClickHandler = function() {
    var that = this;
    this.clickHandler = function(e) {
        // Note that "if (that._listeditor) { return; }" does something very different...
        // it stops even propagation apparently, even without a "return false;"
        if (!that._listeditor) {
            // If the clickHandler was left bound after the MR hid, we can
            // seriously mess with other parts of the app. So we'll double check.
            if (!that.isShown && !that.$dropdownContainer.is(':visible')) { return; }
            var $resultRow = $(e.target).closest('.mr-dropdown-item');
            if ($resultRow.length) {
                e.preventDefault();
                that.setActiveResult(that._getIndex($resultRow));
                that.selectActiveResult(e);
                return false;
            } else if ($(e.target).hasClass("mr-input-field") && (e.target === that.$inputField.get(0))) {
                return;
            } else {
                that.hide(); // mimic blur
                if (that._multilistClickOffFn) { that._multilistClickOffFn(that); }
                return false;
            }
        }
    };
    /* Attach these two to the MR container itself. They use binds, so they will trigger
       before any delegate-controlled events that might be checking isClickBinded */
    this.mousedownHandler = function() { that.isBeingClicked = true; };
    this.mouseupHandler = function() { that.isBeingClicked = false; };
    if (!this.isClickBinded) {
        $(document).on('click', this.clickHandler);
        this.$dropdownContainer.on('mousedown', this.mousedownHandler)
            .on('mouseup', this.mouseupHandler);
        this.isClickBinded = true;
    }
};
el8.uiwidget.NewMindreader.prototype.unbindClickHandler = function() {
    if (this.clickHandler) {
        $(document).unbind('click', this.clickHandler);
        this.$dropdownContainer.unbind('mousedown', this.mousedownHandler)
            .unbind('mouseup', this.mouseupHandler);
        this.isClickBinded = false;
    }
};

// ***************************
// Navigation and rendering methods
// ***************************
el8.uiwidget.NewMindreader.prototype.isDropdownDisplayed = function() {
    return this.$dropdownContainer && !this.$dropdownContainer.is(":hidden");
};
el8.uiwidget.NewMindreader.prototype.resetScroll = function() {
    this.$dropdownContent.scrollTop(0);
};
el8.uiwidget.NewMindreader.prototype.numResults = function() {
    return $(".mr-result-item", this.$dropdownContainer).length;
};
el8.uiwidget.NewMindreader.prototype.numItems = function() {
    return $(".mr-dropdown-item", this.$dropdownContainer).length;
};
el8.uiwidget.NewMindreader.prototype.getNthItem = function(n) {  // 0-indexed
    if (this.isDropdownDisplayed()) {
        var mod_n = n % this.numItems();   // modulo length of results array + one for user input
        return $(".mr-dropdown-item", this.$dropdownContainer).eq(mod_n);
    }
    return null;
};
el8.uiwidget.NewMindreader.prototype.activateNext = function() {
    var index = this.activeIndex + 1;
    if (index >= this.numItems())  {
        index = this.activeIndex;  // Don't move below bottom
    } else {
        this.setActiveResult(index);
    }
};
el8.uiwidget.NewMindreader.prototype.activatePrev = function() {
    var index = this.activeIndex - 1;
    if (index < 0) {
        index = this.activeIndex; // Don't move above top; don't do anything
    } else {
        this.setActiveResult(index);
    }
};
el8.uiwidget.NewMindreader.prototype.hasResults = function(includeActions) {
    if (includeActions) { return this.numItems() >= 1; }
    return (this.numResults() >= 1);
};
el8.uiwidget.NewMindreader.prototype.setActiveResult = function(index, noIndexSet, automatedSelection) {

    automatedSelection = automatedSelection || false; //true to avoid freezing the MR

    if (this.$activeResult) { this.$activeResult.removeClass("mr-selected"); }
    this.$activeResult = null;
    this.activeIndex = -1;
    this.unfreeze();

    if ((index !== null) && (index >= 0) && this.isDropdownDisplayed()) {
        this.$activeResult = this.getNthItem(index);
        if (this.$activeResult) {
            this.$activeResult.addClass("mr-selected");
            this.activeItem = this._fetchItem(
                this.$activeResult.attr("_mr_list"),
                this.$activeResult.attr("_mr_index")*1
            );
        }
        // If index is 0, then can set index anyway so
        // down arrow doesn't have to be hit twice to select
        if (!noIndexSet || index === 0) {
            this.activeIndex = index;
        }

        if (!automatedSelection) {
            //TODO: unknown why this freezing is here, but we're limiting
            // the scope of the change for rb_app_20120918
            this.freeze();

            var that = this;
            var do_unfreeze = function() { that.unfreeze(); };
            setTimeout(do_unfreeze, 10);
        }
    }
};
el8.uiwidget.NewMindreader.prototype.selectActiveResult = function(e) {
    var noBubble = false;
    // prevent any .activeResult that has .el8MRItemDisabled from being selected
    if (this.$activeResult && !this.$activeResult.hasClass("el8MRItemDisabled")) {
        // Should apply to any of the "mr-result-item' entries
        if (this.activeItem) {
            this.setSelectedItem(e, this.activeItem);
            if (this._focusAfterSelect) { this.$inputField.focusFocus(); } // expect to happen above hiding mindreader

        // Else, the "mr-action-item" entries
        } else if (this.$activeResult.hasClass("mr-action-item")) {
            var actionIndex = this.$activeResult.attr("_mr_index")*1;
            var inputVal = this.$inputField.val();
            if (inputVal === this.$inputField.attr('_infotext')) { inputVal = ''; }
            this._actions[actionIndex]['actionFn'](inputVal);
            if (!this._actions[actionIndex]['preserveValOnClick']) {
                this.setInputVal('');
                this.$inputField.blur();
            }
            noBubble = true;

        // Finally, the "mr-input-item" entry
        }  else {
            noBubble = false;
        }
        this.hide();
    }
    this.madeSelection = true;
    return noBubble;
};
el8.uiwidget.NewMindreader.prototype.createDropdownItem = function(list, index, classes) {
    var that = this;
    var $item = $(el8.template.uiwidget.NewMindreader.item({
        listName: list,
        index: index,
        classes: classes
    }));
    $item.on('mousemove', _.debounce(function(e) {
        /* This terrible keydownScroll flag is used to hack around a bug with the mousemove event.
         * When we scroll from keydown/keyup, the position of mindreader items changes and they
         * "scroll", which triggers this event. So if the mouse happens to be over a mindreader,
         * after paging down, the mouse will jump back to the cursor location. We use this flag
         * to ignore the first mousemove after a keydown. */
        if (that._keydownScroll) {
            that._keydownScroll = false;
            return;
        }
        that.isEngaged = true;
        that.setActiveResult(that._getIndex(this));
    }, el8.util.consts.MOUSEMOVE_RATE, true));
    return $item;
};

// ***************************
// Cache management
// ***************************
el8.uiwidget.NewMindreader.prototype.clearCache = function() { this.cache = {}; };
el8.uiwidget.NewMindreader.prototype.addToCache = function(q, results) {
    if (q) { this.cache[q] = results; }
};
el8.uiwidget.NewMindreader.prototype.lookupInCache = function(q) {
    if (this.cache.hasOwnProperty(q)) {
        return this.cache[q];
    }
    return false;
};

// ***************************
// User input
// ***************************
el8.uiwidget.NewMindreader.prototype.hasInput = function() {
    return this.isValidInput(this.$inputField.val());
};
el8.uiwidget.NewMindreader.prototype.isValidInput = function(str) {
    return (str.toLowerCase() !== this.ignoreStr.toLowerCase());
};
el8.uiwidget.NewMindreader.prototype.getInputVal = function() {
    var val = this.$inputField.val();
    if (val.toLowerCase() === this.ignoreStr.toLowerCase()) {
        return '';
    }
    return val;
};
el8.uiwidget.NewMindreader.prototype.setInputVal = function(val, noTrigger) {
    this.$inputField.val(val);
    if (!noTrigger) { this.$inputField.change(); }
};

// ***************************
// Core methods
// ***************************
el8.uiwidget.NewMindreader.prototype.reset = function() {
    this.resultsMap = {};
    this.setActiveResult(null);
};
el8.uiwidget.NewMindreader.prototype.position = function() {
    var anchorHeight = this._dropdownAnchor.outerHeight();
    var leftPosition;

    if (this._overflowInputToLeft && this._dropdownAnchor.width() < this._containerWidth) {
        // We're aligning the right side of the MR to the right side of the anchor here
        var anchorRightEdge = this._dropdownAnchor.offset()['left'] + this._dropdownAnchor.width();
        // 5 is just a buffer to make the autocomplete start slightly inside the input
        leftPosition = anchorRightEdge - this._containerWidth - 5;
    } else {
        leftPosition = this._dropdownAnchor.offset()['left'] + (this._containerLeftOffset || 0);
    }

    // Set top and bottom offsets based on anchor position;
    // when anchoring from the top (default behavior) calculate
    // the top and set bottom to auto; when anchoring from the
    // bottom, calculate bottom and set top to auto;

    var bottomOffset = this._anchorFromBottom
        ? this._UILayoutFn().getAppHeight() - this._dropdownAnchor.offset()['top']
        : 'auto';

    var topOffset = this._anchorFromBottom
        ? 'auto'
        : this._dropdownAnchor.offset()['top'] + (this._containerTopOffset || 0) + anchorHeight;

    this.$dropdownContainer.css({
        'left': leftPosition,
        'top': topOffset,
        'bottom': bottomOffset,
        'z-index': this._HIGH_Z_INDEX,
        'width': this._containerWidth
    });
};
el8.uiwidget.NewMindreader.prototype.adjustHeight = function() {
    // needs to run after the mindreader is showing so the position is set

    // Calculate pixels to the nearest edge based on whether
    // we are anchoring from the top or the bottom
    var pixelsToEdge = this._anchorFromBottom
        ? this.$dropdownContainer.position().top - 10
        : this._UILayoutFn().getAppHeight() - this.$dropdownContainer.position().top - 10;

    // Set the container height to the smaller of the desired
    // container height or the distance to the edge of the screen
    this.$dropdownContent.css({
        'max-height': Math.min(this._containerHeight, pixelsToEdge)
    });
};
el8.uiwidget.NewMindreader.prototype.show = function(force) {
    if ((this.hasInput() || force) && !this.isShown) {
        this.isShown = true;
        this.position();
        this.$dropdownContainer.show();
        this.adjustHeight();
        if (this._fixedPosActions) {
            $('.mr-results', this.$dropdownContainer).css('padding-bottom', this.$actionsSection.outerHeight());
        }
        this.bindClickHandler();
    }
};
el8.uiwidget.NewMindreader.prototype.hide = function() {
    // TODO In the future, consider clearing cache at this point
    this.clearRequest();
    if (this.isShown || this.$dropdownContainer.is(':visible')) {
        this.isShown = false;
        if (this.hasActivity) {
            this.hasActivity = false;
        }
        this.isEngaged = false; // reset
        this.reset();
        this.unbindClickHandler();
        this.resetResultsDisplay();
        this.$dropdownContainer.hide();
        if (this._hideFn) { this._hideFn(); }
    }
};
el8.uiwidget.NewMindreader.prototype.enable = function() {
    this.isEnabled = true;
};
el8.uiwidget.NewMindreader.prototype.disable = function() {
    this.hide();
    this.isEnabled = false;
};
el8.uiwidget.NewMindreader.prototype.freeze = function() { this.isFrozen = true;};
el8.uiwidget.NewMindreader.prototype.unfreeze = function() { this.isFrozen = false;};
el8.uiwidget.NewMindreader.prototype.checkIsBeingClicked = function() { return this.isBeingClicked;};
el8.uiwidget.NewMindreader.prototype.checkIsEngaged = function() { return this.isEngaged;};
el8.uiwidget.NewMindreader.prototype.checkIsVisible = function() { return this.isShown;};

// ************************
// Utility methods
// ************************
el8.uiwidget.NewMindreader.prototype._fetchItem = function(list, index) {
    if (this.resultsMap[list] && !isNaN(index)) {
        return this.resultsMap[list][index];
    }
    return null;
};
el8.uiwidget.NewMindreader.prototype._getIndex = function($div) {
    return $('.mr-dropdown-item', this.$dropdownContainer).index($div);
};
